const normalizeSearchText = (value) =>
  String(value ?? "").trim().replace(/\s+/g, " ").toLowerCase();

export const matchesLoanCardName = (name, search) =>
  normalizeSearchText(name).includes(normalizeSearchText(search));
